module.exports = __webpack_public_path__ + "static/img/fsc_ttl.516f516.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/fsc_ttl.svg
// module id = BWK5
// module chunks = 0